module.exports = __webpack_public_path__ + "static/media/1040813300.28f7e4b4.jpg";